import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from "@angular/material/core";
import {ProgressSpinnerMode} from "@angular/material/progress-spinner";
import { Router } from '@angular/router';
import { CountdownConfig, CountdownEvent } from 'ngx-countdown';
import { InitializeMasterPassQRCodeResponse } from 'src/app/interfaces/master-pass/InitializeMasterPassQRCodeResponse';
import { Session } from 'src/app/interfaces/session-data';
import { MasterPassService } from 'src/app/services/master-pass/master-pass.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-masterpass-version-two',
  templateUrl: './masterpass.component.html',
  styleUrls: ['./masterpass.component.scss']
})
export class MasterpassComponent implements AfterViewInit, OnInit, OnDestroy {
  paymentMethod: string;
  paymentMethodImg = '';
  redirectUrl;
  loading = true;

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;

  //Countdown
  config: CountdownConfig = { leftTime: 5, format: 's' };
  countDownComplete = false;

  // iframe
  public iframeLoaded:boolean;
  public iframePostback:boolean;
  private boundHandleIframeLoad:any;
  @ViewChild("output_frame") private iframeRef!: ElementRef<HTMLIFrameElement>;

  hidePgLogo = false;
  sessionData: Session;

  constructor(
    private masterPassService: MasterPassService,
    private sessionService: SessionService,
    private router: Router,
  ) {
    sessionStorage.setItem('selected-payment', 'master_pass');
    this.paymentMethod = 'master_pass';
    this.paymentMethodImg = `src/assets/icons/Payment_Cards/svg/image_${this.paymentMethod}.png`;
    this.boundHandleIframeLoad = this.handleIframeLoad.bind(this);
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.boundHandleIframeLoad);
  }

  ngOnInit(): void {
    this.iframeLoaded = false;
    this.iframePostback = false;
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.hidePgLogo = this.sessionData?.sessionDisplayInformation?.hidePgLogo === 'true';
    window.addEventListener('message', this.boundHandleIframeLoad, false);
  }
  
  ngAfterViewInit(): void {
    this.masterPassService.initializeQRCode(sessionStorage.getItem('sessionToken')).subscribe((data: InitializeMasterPassQRCodeResponse) => {
      this.iframeRef.nativeElement!.src = data.redirectUrl;
    });
  }

  private handleIframeLoad(event: MessageEvent) {
    console.log(event);
    // Check if the message is from the expected origin
    if(!/^https:\/\/(?:[a-zA-Z0-9-]+\.)*adumoonline\.com(\/|$)/.test(event.origin)) return;

    // Handle the response from the iframe
    if (event.data.status === 'COMPLETED' && event.data.paymethod==='MASTERPASS') {
      // Redirect the parent window
      this.iframeLoaded = false;
      this.iframePostback = true;
      this.navigateToStatus();
    }
  }

  navigateToStatus() {
    this.loading = false;
    this.router.navigate(
      [`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);
  }

  onCountDownEvent(event: CountdownEvent) {
    if (event.action === "done") {
      this.countDownComplete = true;
    }
  }

  iframeOnLoad(event:any){
    if(!this.iframePostback) {
      this.iframeLoaded = true;
    }
  }
}
